import ApiService from '../api.service'

type NotificationVisualMode = 'toast' | 'modal' | 'badge'
type NotificationSeverity = 'info' | 'success' | 'warning' | 'error'
type JsonValue =
    | string
    | number
    | boolean
    | null
    | { [key: string]: JsonValue }
    | JsonValue[]

export type NotificationSilentMessage = {
    id: string
    mode: 'silent'
    module: string
    type: string
    body: JsonValue
    createdAt?: string
}

export type NotificationVisualMessage = {
    id: string
    title: string
    message: string
    onClickUrl?: string
    severity?: NotificationSeverity
    mode: NotificationVisualMode[]
    createdAt?: string
}

export type NotificationMessage =
    | NotificationSilentMessage
    | NotificationVisualMessage

const missed = new ApiService<never>('notifications/missed')

const service = new ApiService<NotificationMessage>('notifications')

export const notificacoes_api = Object.assign(service, {
    missed,
})
